"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["className", "title", "toolTip", "tooltipAlignment", "stringProvider", "minimal", "variant", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { ContentCopyIcon } from '@autoguru/icons';
import { Box, Button, Icon, Tooltip } from '@autoguru/overdrive';
import { EAlignment } from '@autoguru/overdrive/dist/components/Positioner/alignment';
import { useClipboardCopy } from '../hooks/useClipboardCopy';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const CopyToClipboard = _ref => {
  let {
      className,
      title = 'COPY',
      toolTip = 'Copy to clipboard',
      tooltipAlignment = EAlignment.LEFT,
      stringProvider,
      minimal = true,
      variant = 'secondary',
      size = 'small'
    } = _ref,
    buttonProps = _objectWithoutProperties(_ref, _excluded);
  const [onCopyRequest, tip] = useClipboardCopy({
    stringProvider
  });
  return /*#__PURE__*/_jsx(Tooltip, {
    closeAfter: 3e3,
    alignment: tooltipAlignment,
    label: tip || toolTip,
    children: /*#__PURE__*/_jsx(Box, {
      className: className,
      children: /*#__PURE__*/_jsxs(Button, _objectSpread(_objectSpread({
        minimal: minimal,
        variant: variant,
        size: size
      }, buttonProps), {}, {
        onClick: onCopyRequest,
        children: [title, /*#__PURE__*/_jsx(Icon, {
          icon: ContentCopyIcon
        })]
      }))
    })
  });
};